import { h } from 'preact'
import { FunctionComponent } from 'preact/compat'

import { Button } from 'components/ui'
import { useTranslation } from 'scripts/hooks'
import styles from './index.scss'

type Props = {
  onSubmit: () => void
  disabled?: boolean
}

const SubmitButton: FunctionComponent<Props> = ({ onSubmit, disabled }) => {
  const t = useTranslation()
  return (
    <div className={styles.btnWrapper}>
      <Button onClick={onSubmit} disabled={disabled}>
        {t('submitButton')}
      </Button>
    </div>
  )
}

export default SubmitButton
